import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const Faq = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section className="faq section-light" id="faq" aria-labelledby="faq-title" data-testid="faq-section">
      <div className="shell faq-layout">
        <div className="faq-title-wrap">
          <Reveal className="section-index dark" aria-hidden="true">{t.faq.index}</Reveal>
          <Reveal><p className="kicker dark">{t.faq.kicker}</p></Reveal>
          <h2 id="faq-title" className="display-title dark">
            <LineMask delay={0.1}>{t.faq.titleA}</LineMask>
            <LineMask delay={0.22}><span>{t.faq.titleB}</span></LineMask>
          </h2>
        </div>
        <Reveal className="accordion" delay={0.15}>
          {t.faq.items.map((item, i) => (
            <div className={`acc-item ${open === i ? "open" : ""}`} key={item.q}>
              <button
                className="acc-trigger"
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                data-testid={`faq-item-${i}`}
              >
                {item.q}
                <span className="icon" aria-hidden="true">＋</span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    className="acc-body"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }}
                  >
                    <p>{item.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
